import { Icon } from './Icon'

/** An explicitly labelled illustration, never presented as workspace activity. */
export function ConversationPreview() {
  return (
    <div
      className="conversation-preview"
      aria-label="Illustrative conversation preview"
    >
      <div className="preview-orbit" aria-hidden="true" />
      <div className="preview-window">
        <div className="preview-heading">
          <span className="feature-icon tone-indigo">
            <Icon name="bot" />
          </span>
          <div>
            <strong>Your AI assistant</strong>
            <span>Every conversation, a new possibility</span>
          </div>
          <span className="preview-dot" />
        </div>
        <div className="preview-body">
          <p className="preview-message visitor">
            Hi! Can you help me find the right fit?
          </p>
          <div className="preview-reply">
            <span className="mini-spark">
              <Icon name="spark" size={16} />
            </span>
            <p className="preview-message assistant">
              Absolutely. Tell me a little about what you’re looking for.
            </p>
          </div>
          <div className="preview-chips">
            <span>Explore products</span>
            <span>Talk to the team</span>
          </div>
        </div>
        <div className="preview-compose">
          <span>A great conversation starts here</span>
          <span className="preview-send">
            <Icon name="arrow" size={16} />
          </span>
        </div>
      </div>
      <span className="preview-caption">
        PRODUCT PREVIEW · ILLUSTRATIVE EXAMPLE
      </span>
    </div>
  )
}
